import * as React from 'react';
import { getTitle } from './utils';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData } from '../../../../../../selectors/buyPackageModal';
import { Regions } from './Regions';
import { splitRegionNames } from '../../../../../../utils/packages';

const MAX_REGION_NAMES = 2;

export const RegionsContainer = () => {
  const data = useSelector(selectBuyPackageModalData);

  const { regionNames } = data;

  const title = React.useMemo(() => getTitle(regionNames), [regionNames]);
  const { firstRegionNames, restRegionNames } = React.useMemo(
    () => splitRegionNames(regionNames, MAX_REGION_NAMES),
    [regionNames],
  );

  return <Regions title={title} firstRegionNames={firstRegionNames} restRegionNames={restRegionNames} />;
};
